/* Magic Grip: tarjeta de producto (snippets/card-product.liquid)
   1. Círculos de color: al clic cambia la foto, el precio y los links de la tarjeta (SISTEMA 12.3, punto 7).
   2. Agregar al carrito: el envío lo toma UpCart (o <product-form> de Shrine) y abre el carrito.
      Acá solo se marca el botón como cargando (aro de 18 px) hasta que el carrito se abre.
      Si ninguno de los dos está, respaldo por fetch con el mismo resultado.
   3. Sticker de campaña: lo muestra solo entre las fechas de Configuración del tema > Campaña.
   Sin animaciones por JS: el único movimiento es CSS y se apaga con prefers-reduced-motion.
   Los eventos van delegados en document, así siguen funcionando con shopify:section:load
   y con las tarjetas que agrega "Ver más". */
(function () {
  if (window.__mgCardBound) return;
  window.__mgCardBound = true;

  /* ---------- Sticker de campaña ----------
     Entre data-from y data-until (hora de Argentina) pone .mg-camp-live en <html>. Revisa cada minuto. */
  function campDate(t) {
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/.exec(t || '');
    return m ? Date.parse(m[1] + '-' + m[2] + '-' + m[3] + 'T' + (m[4] || '00') + ':' + (m[5] || '00') + ':00-03:00') : NaN;
  }
  function campCheck() {
    var el = document.querySelector('[data-mg-camp]');
    if (!el) return;
    var now = Date.now();
    var live = !(now < campDate(el.getAttribute('data-from'))) && now < campDate(el.getAttribute('data-until'));
    document.documentElement.classList.toggle('mg-camp-live', live);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', campCheck);
  else campCheck();
  document.addEventListener('shopify:section:load', campCheck);
  setInterval(campCheck, 60000);

  /* ---------- Color ---------- */
  function setText(card, selector, value) {
    var el = card.querySelector(selector);
    if (el && value) el.textContent = value;
  }

  function pickSwatch(sw) {
    var card = sw.closest('.mg-card');
    if (!card) return;
    var list = sw.closest('.mg-card__swatches');
    if (list) {
      list.querySelectorAll('[data-mg-swatch]').forEach(function (o) {
        o.setAttribute('aria-pressed', o === sw ? 'true' : 'false');
      });
    }

    var img = card.querySelector('.mg-card__img--first');
    var src = sw.getAttribute('data-img');
    if (img && src) {
      var srcset = sw.getAttribute('data-srcset');
      if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
      img.setAttribute('src', src);
      /* La segunda foto es del producto, no del color: deja de mostrarse al elegir */
      card.classList.add('is-variant');
    }

    var url = sw.getAttribute('data-url');
    if (url) {
      card.querySelectorAll('[data-mg-card-link]').forEach(function (a) { a.setAttribute('href', url); });
    }

    /* Precio sin animación */
    setText(card, '[data-mg-price-amount]', sw.getAttribute('data-price'));
    setText(card, '[data-mg-price-cuota]', sw.getAttribute('data-cuota'));
    var compare = card.querySelector('[data-mg-price-compare]');
    if (compare && sw.hasAttribute('data-price')) {
      var old = sw.getAttribute('data-compare');
      compare.textContent = old || '';
      compare.hidden = !old;
    }
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-mg-swatch]');
    if (!sw) return;
    e.preventDefault();
    pickSwatch(sw);
  });

  /* ---------- Agregar al carrito: respaldo si Shrine no tomó el formulario ---------- */
  function cartDrawer() {
    var el = document.querySelector('cart-drawer');
    return el && typeof el.renderContents === 'function' ? el : null;
  }
  function sectionsFor(drawer) {
    var list = ['cart-drawer', 'cart-icon-bubble'];
    try {
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        list = drawer.getSectionsToRender().map(function (x) { return x.section || x.id; });
      }
    } catch (err) {}
    return list;
  }

  /* Cargando hasta que se abre el carrito (UpCart marca el body; Shrine abre cart-drawer) */
  function cartIsOpen() {
    if (document.body.classList.contains('upcartPopupShow')) return true;
    var drawer = document.querySelector('cart-drawer');
    return !!(drawer && (drawer.classList.contains('active') || drawer.classList.contains('animate')));
  }
  function markLoading(btn) {
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    var done = false;
    var observer = null;
    function finish() {
      if (done) return;
      done = true;
      if (observer) observer.disconnect();
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
    if ('MutationObserver' in window) {
      observer = new MutationObserver(function () { if (cartIsOpen()) finish(); });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      var drawer = document.querySelector('cart-drawer');
      if (drawer) observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    window.setTimeout(finish, 6000);
    return finish;
  }

  function handledElsewhere() {
    return !!(document.getElementById('upCart') || (window.customElements && window.customElements.get('product-form')));
  }

  /* UpCart toma el clic antes de que exista un submit: el estado cargando se marca en el clic */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mg-card__add');
    if (!btn || btn.classList.contains('is-loading') || !handledElsewhere()) return;
    markLoading(btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-mg-card-form')) return;
    if (handledElsewhere()) return;
    var btn = form.querySelector('.mg-card__add');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var routes = window.routes || {};
    var addUrl = routes.cart_add_url || '/cart/add';
    if (!/\.js$/.test(addUrl)) addUrl += '.js';
    var cartUrl = routes.cart_url || '/cart';
    var drawer = cartDrawer();
    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    var body = { items: [{ id: id, quantity: 1 }] };
    if (drawer) {
      body.sections = sectionsFor(drawer);
      body.sections_url = window.location.pathname;
    }

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (json) {
      if (json.status && json.status >= 400) throw new Error(json.description || 'error');
      if (!drawer) { window.location.href = cartUrl; return; }
      try {
        drawer.renderContents(json);
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'mg-card', productVariantId: id });
        }
      } catch (err) {
        window.location.href = cartUrl;
      }
    }).catch(function () {
      /* Sin stock o error de red: la PDP explica qué pasa */
      var link = form.closest('.mg-card');
      link = link && link.querySelector('.mg-card__title a');
      if (link && link.href) window.location.href = link.href;
    }).then(function () {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    });
  }, true);
})();
